import { gql } from "@apollo/client/core";
import {
  GetSessionConfigQueryResponse,
  SessionConfig,
} from "../../../../../graphql/types/config";

type FetchSessionConfigApiResponse = {
  sessionConfig: SessionConfig;
};

export type GetSessionConfigOperationResponse =
  GetSessionConfigQueryResponse<FetchSessionConfigApiResponse>;

export const GET_SESSION_CONFIG = gql`
  query GetSessionConfig {
    getSessionConfig {
      sessionConfig {
        taskAddLimit
        trackedTaskLimit
      }
    }
  }
`;
